import React, { memo, useState } from 'react'
import { message } from 'antd'
import { FileUpload, useTraversal } from '@guillotinaweb/react-gmi'

import { ColorPicker } from '../../../components/color_picker'
import { I18NField } from '../../../components/i18nfield'
import { ProductSelector } from '../../../components/product-selector'
import { getCdnUrl, setLangs } from '../../../consts'
import { Fragment } from 'react'

const Empty = () => null

export const ProductBannerForm = memo(({ selected, edit, langs }) => {
  const Ctx = useTraversal()
  const [uploading, setUploading] = useState(false)

  function onUploadBanner(lang) {
    return async (file) => {
      setUploading(true)
      const filename = `home/${Ctx.state.context['@name']}`
      const res = await Ctx.client.upload(Ctx.path, file, filename)

      if (res.status >= 300) {
        message.error('Error uploading the image')
        setUploading(false)
        return
      }

      const { path } = await res.json()
      const src = `/${path}`
      const image = selected.image || {}
      const isFirstImage = !Object.values(image).find((v) => v)

      edit('image', isFirstImage ? setLangs(src) : { ...image, [lang]: src })
      setUploading(false)
    }
  }

  return (
    <I18NField key={langs.join()} langs={langs} Widget={Empty}>
      {(lang) => (
        <Fragment key={lang}>
          <ColorPicker
            label="Background color"
            onChange={(e) => edit('bgColor', e.target.value)}
            value={selected.bgColor}
          />
          <label className="label">Image</label>
          <FileUpload
            accept="image/*"
            onChange={onUploadBanner(lang)}
            label={uploading ? 'Uploading...' : 'Upload an image'}
          />
          {selected.image?.[lang] && (
            <img
              src={`${getCdnUrl()}${selected.image?.[lang]}`}
              alt="Banner preview"
            />
          )}
          <label className="label">alt</label>
          <input
            className="input"
            onChange={(e) => {
              edit('title', {
                ...(selected.title || {}),
                [lang]: e.target.value,
              })
            }}
            value={selected.title?.[lang]}
          />

          <label className="label">Product</label>
          <ProductSelector
            id={selected.id}
            type="refs"
            products={selected.reference}
            onChange={(refs) => {
              if (refs.length > 1) {
                return message.error('Only 1 product is allows.')
              }
              edit('reference', refs[0])
            }}
          />
        </Fragment>
      )}
    </I18NField>
  )
})
